/*
//-------------------------------------------------------
//   Copyright (c) 2020 Templa Computer Systems Ltd
//
//   App:        EmployeePortal.UI
//   Object:     history.js
//   Details:    set up history
//
//
// Log      Date   By  Scan Description
// -----  -------- --- ---- ------------------------------
// 112897 28/04/21 JC  M01  Added createHashHistory
//-------------------------------------------------------
*/

import { createBrowserHistory, createHashHistory } from 'history';

/* M01 - if we're in standalone browser mode then use hash history rather than browser as iOS/android do not work properly */
function configureHistory() {
  return window.matchMedia('(display-mode: standalone)').matches
    ? createHashHistory()
    : createBrowserHistory()
}

export const history = configureHistory();


